


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import IconClose from '@/components/IconClose.vue';

@Component({ components: { IconClose } })
export default class RegulationsDialog extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) regulationsUrl!: string;
}
